import { render } from "./BalanceCard.vue?vue&type=template&id=5f373223&scoped=true"
import script from "./BalanceCard.vue?vue&type=script&lang=js"
export * from "./BalanceCard.vue?vue&type=script&lang=js"

import "./BalanceCard.vue?vue&type=style&index=0&id=5f373223&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f373223"]])

export default __exports__